export function initPendo(userId: string, userEmail: string, companyId: string, companyName: string) {
  // eslint-disable-next-line
  if (!userId || !userEmail || !companyId || !companyName || !window.pendo) return;
  // eslint-disable-next-line
  window.pendo.initialize({
    visitor: {
      id: userId,
      email: userEmail,
    },

    account: {
      id: companyId,
      name: companyName,
    },
  });
}
